import React, { Component } from "react";
import { Navbar, NavbarBrand, Nav, NavItem, NavLink } from "reactstrap";
import "../../styling/shared/header.css";
import logoPartner from "../../assets/images/logo1.png";

class Header extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <Navbar className="header" dark color="primary" fixed="top" expand="md">
        <div className="container">
          <NavbarBrand href="/">
            <img className="header__logo" src={logoPartner} alt="Logo"></img>
          </NavbarBrand>
          <Nav className="ml-auto" navbar>
            <NavItem className="header__navitem"></NavItem>
          </Nav>
        </div>
      </Navbar>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/component/shared/header.js